import { Component, OnInit } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';

@Component({
    selector: 'wm-test-input-activity-view',
    imports: [],
    templateUrl: './test-input-activity-view.component.html',
    styleUrl: './test-input-activity-view.component.css'
})
export class TestInputActivityViewComponent extends ActivityView
  implements OnInit {
  ngOnInit(): void {

  }

}
